"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameSteamMatchToJSON = exports.OWGameSteamMatchFromJSONTyped = exports.OWGameSteamMatchFromJSON = void 0;
var runtime_1 = require("../runtime");
function OWGameSteamMatchFromJSON(json) {
    return OWGameSteamMatchFromJSONTyped(json, false);
}
exports.OWGameSteamMatchFromJSON = OWGameSteamMatchFromJSON;
function OWGameSteamMatchFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'confidence': !(0, runtime_1.exists)(json, 'confidence') ? undefined : json['confidence'],
        'method': !(0, runtime_1.exists)(json, 'method') ? undefined : json['method'],
        'overwolfName': !(0, runtime_1.exists)(json, 'overwolfName') ? undefined : json['overwolfName'],
        'steamName': !(0, runtime_1.exists)(json, 'steamName') ? undefined : json['steamName'],
    };
}
exports.OWGameSteamMatchFromJSONTyped = OWGameSteamMatchFromJSONTyped;
function OWGameSteamMatchToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'confidence': value.confidence,
        'method': value.method,
        'overwolfName': value.overwolfName,
        'steamName': value.steamName,
    };
}
exports.OWGameSteamMatchToJSON = OWGameSteamMatchToJSON;
